import React, { useEffect, useState } from "react";
import "./Blog.scss";
import DOMPurify from "dompurify";
import axios from "axios";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { toast } from "react-toastify";
import Loader from "../comp/loader/Loader";

const Addblog = () => {
  const [blogForm, setBlogForm] = useState({
    date: "",
    category: "",
    title: "",
    description: "",
    language: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    alter_text: "",
  });
  const [imageData, setDataImage] = useState(null);

  const [loader, setLoader] = useState(false);

  const sanitizeConfig = {
    ALLOWED_TAGS: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "img",
      "p",
      "ul",
      "li",
      "ol",
      "br",
      "iframe",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "style"],
  };
  const sanitizedDescription = DOMPurify.sanitize(
    blogForm.description,
    sanitizeConfig
  );

  const navigate = useNavigate();

  const getBlogById = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PORT_BACKEND}blog/getBybId?bId=${id}`
      );

      const data = response?.data?.data;

      setBlogForm((prev) => ({
        ...prev,
        bid: data.bid,
        date: data.date,
        category: data.category,
        title: data.title,
        description: data.description,
        language: data.language,
        meta_title: data.meta_title,
        meta_description: data.meta_description,
        meta_keywords: data.meta_keywords,
        alter_text: data.alter_text,
      }));

      setDataImage(data.image);
    } catch (error) {
      console.log(error);
    }
  };
  const [searchParams] = useSearchParams();
  const location = useLocation();
  useEffect(() => {
    const id = searchParams.get("id");

    if (id) {
      getBlogById(id);
    }
  }, []);

  const addBlog = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("featureimage", imageData);
      formData.append("blog", JSON.stringify(blogForm));

      const id = searchParams.get("id");

      let response;
      if (id) {
        response = await axios.put(
          `${process.env.REACT_APP_PORT_BACKEND}blog/updateblog`,
          formData
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_PORT_BACKEND}blog/addblog`,
          formData
        );
      }

      setBlogForm({
        date: "",
        category: "",
        title: "",
        description: "",
        language: "",
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        alter_text: "",
      });

      setDataImage(null);
      toast.success("blog has been added");
      navigate("/bloglist");
      window.location.reload();
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <Loader />}

      <div class="add_blog parent">
        <div class="add_blog_form">
          <form action="" onSubmit={addBlog}>
            <div class="form_row language-select">
              <label for=""> Select Image </label>
              <input
                type="file"
                onChange={(e) => setDataImage(e.target.files[0])}
              />


              
            </div>

            <div class="form_row">
                 <label for=""> Add Alt Text </label>
              <input
                type="text"
                value={blogForm.alter_text}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, alter_text: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for="">Select Language</label>
              <select
                className="toggle-dropdown"
                value={blogForm.language}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, language: e.target.value });
                }}
              >
                <option value="English">English</option>
                <option value="Marathi">Marathi</option>
              </select>
            </div>
            <div class="form_row">
              <label for=""> Select Date </label>
              <input
                type="date"
                value={blogForm.date}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, date: e.target.value });
                }}
              />
            </div>
            <div class="form_row">
              <label for=""> Category </label>
              <input
                type="text"
                value={blogForm.category}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, category: e.target.value });
                }}
              />
            </div>
            <div class="form_row">
              <label for=""> title</label>
              <input
                type="text"
                value={blogForm.title}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, title: e.target.value });
                }}
              />
            </div>
             <div class="form_row">
                 <label for=""> Add Meta Title </label>
              <input
                type="text"
                value={blogForm.meta_title}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, meta_title: e.target.value });
                }}
              />
            </div>
             <div class="form_row">
                 <label for=""> Add Meta Description </label>
              <input
                type="text"
                value={blogForm.meta_description}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, meta_description: e.target.value });
                }}
              />
            </div>
             <div class="form_row">
                 <label for=""> Add Meta Keywords </label>
              <input
                type="text"
                value={blogForm.meta_keywords}
                onChange={(e) => {
                  setBlogForm({ ...blogForm, meta_keywords: e.target.value });
                }}
              />
            </div>

            <div class="form_row">
              <label for=""> description</label>
              <div style={{ width: "100%" }}>
                <CKEditor
                  editor={ClassicEditor}
                  data={blogForm.description}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setBlogForm({ ...blogForm, description: data });
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "min-height",
                        "200px",
                        editor.editing.view.document.getRoot()
                      );
                    });
                  }}
                />
              </div>
            </div>

            <div class="form_row">
              <input className="btn" type="submit" />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Addblog;
